import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { saveAs } from 'file-saver';

const PdfViewer = ({ pdfUrl }) => {
    const handleDownload = () => {
        saveAs(pdfUrl, 'file.pdf'); // Adjust the file name if needed
    };

    return (
        <div>
            <div className="download-button-container">
                <button className="download-button" onClick={handleDownload}>Download PDF</button>
            </div>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfUrl} />
            </Worker>
        </div>
    );
};

export default PdfViewer;
